import React, { Fragment } from 'react';
import { useSelector} from 'react-redux'
import { useNavigate } from 'react-router-dom';
import EditableInput from './EditableInput';
import {Helmet} from "react-helmet"
import SerialSearch from './SerialSearch';
import AddNewDevice from './AddNewDevice'

import local from "./local/user_localisation"

export default function User(){
    const navigate = useNavigate();
    const setup = useSelector(state => state.site.setup);

    // Явно проверяем, что язык валиден, иначе используем 'ru' по умолчанию
    let LANG = ['ru', 'en', 'de'].includes(setup.lang) ? setup.lang : 'ru';

if(localStorage.user){
    var user = JSON.parse(localStorage.getItem("user"));
} else {
    navigate(`/${LANG}/login`, { replace: true });
    return null;
}


if(user.service==='y'){
    return(
        <Fragment>
            <SerialSearch/>
        </Fragment>
    )
}

return(
<Fragment>
    <Helmet>
      <title>{local[LANG].msg}</title>
    </Helmet>
    <div className='pages lk'>
    <h2 className='tae'>{local[LANG].msg}</h2>
        <EditableInput tag='usr' content={user.usr}/>
        <EditableInput tag='cntr' content={user.country}/>
        <EditableInput tag='fio' content={user.fio}/>
        <EditableInput tag='tel' content={user.phone}/>
        <EditableInput tag='eml' content={user.email} inactive/>
        <AddNewDevice/>
        
    </div>
</Fragment>
)
} 